(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', './Link', './Wantedly', 'react-icons/fa6', 'prop-types'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('./Link'), require('./Wantedly'), require('react-icons/fa6'), require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.Link, global.Wantedly, global.fa6, global.propTypes);
    global.SocialLink = mod.exports;
  }
})(this, function (exports, _react, _Link, _Wantedly, _fa, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _Link2 = _interopRequireDefault(_Link);

  var _Wantedly2 = _interopRequireDefault(_Wantedly);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SocialLink = function (_React$Component) {
    _inherits(SocialLink, _React$Component);

    function SocialLink() {
      _classCallCheck(this, SocialLink);

      return _possibleConstructorReturn(this, (SocialLink.__proto__ || Object.getPrototypeOf(SocialLink)).apply(this, arguments));
    }

    _createClass(SocialLink, [{
      key: 'buildSocialIcon',
      value: function buildSocialIcon(label) {
        switch (label) {
          case 'facebook':
            return {
              color: '#0078c9',
              icon: _react2.default.createElement(_fa.FaFacebookF, null)
            };
          case 'twitter':
            return {
              color: '#00a9f2',
              icon: _react2.default.createElement(_fa.FaXTwitter, null)
            };
          case 'linkedin':
            return {
              color: '#004a7d',
              icon: _react2.default.createElement(_fa.FaLinkedinIn, null)
            };
          case 'googleplus':
            return {
              color: '#d25533',
              icon: _react2.default.createElement(_fa.FaGooglePlusG, null)
            };
          case 'youtube':
            return {
              color: '#cc181e',
              icon: _react2.default.createElement(_fa.FaYoutube, null)
            };
          case 'xing':
            return {
              color: '#00a9f2',
              icon: _react2.default.createElement(_fa.FaXing, null)
            };
          case 'wantedly':
            return {
              color: '#00a4bb',
              icon: _react2.default.createElement(_Wantedly2.default, null)
            };
          case 'wechat':
            return {
              color: '#00a4bb',
              icon: _react2.default.createElement(_fa.FaWeixin, null)
            };
        }
        return false;
      }
    }, {
      key: 'render',
      value: function render() {
        var linkStyles = {
          display: 'flex',
          height: '41px',
          width: '41px',
          margin: '7px',
          fontSize: '18px',
          backgroundColor: '#262626',
          borderRadius: '100%',
          color: '#a8a8a8',
          transition: 'all 0.2s ease-in-out',
          alignItems: 'center',
          justifyContent: 'center'

        };
        var network = this.buildSocialIcon(this.props.network);

        // If the network is not found, return empty div
        if (!network) {
          return _react2.default.createElement('div', null);
        }

        // Override styles if there is overrides
        if (this.props.styleOverrides) {
          Object.assign(linkStyles, this.props.styleOverrides);
        }

        return _react2.default.createElement(
          _Link2.default,
          {
            href: this.props.href,
            className: 'text-center social-link ' + this.props.network,
            target: '_blank',
            style: linkStyles,
            hoverStyles: {
              color: '#fff',
              backgroundColor: network.color
            }
          },
          network.icon
        );
      }
    }]);

    return SocialLink;
  }(_react2.default.Component);

  exports.default = SocialLink;


  SocialLink.propTypes = {
    network: _propTypes2.default.string,
    href: _propTypes2.default.string,
    styleOverrides: _propTypes2.default.object
  };
});